export const createViewerSelectionController = ({
  state,
  refreshSelectionHelper,
  refreshHoverHelper,
  renderInspector,
  syncNodeMappingFormDefaults,
  syncPlacementNodeMappingFormDefaults,
  notifyEmbedSelectionChanged,
  clearNavigationPointHoverState,
  clearHoverHelper,
  clearHoverMarker,
  clearSelectionHelper,
  clearSelectionMarker
}) => {
  const clearNodeSelectionState = () => {
    state.selectedObject = null
    state.selectedPoint = null
  }

  const clearPlacementSelectionState = () => {
    state.selectedPlacement = null
    state.selectedPlacementObject = null
    state.selectedPlacementPoint = null
  }

  const clearNavigationPointSelectionState = () => {
    state.selectedNavigationPoint = null
    state.selectedNavigationPointObject = null
  }

  const setHoveredObject = (object, point = null) => {
    state.hoveredObject = object
    state.hoveredPoint = point ? point.clone() : null
    refreshHoverHelper()
  }

  const clearHoveredObject = () => {
    state.hoveredObject = null
    state.hoveredPoint = null
    clearNavigationPointHoverState()
    clearHoverHelper()
    clearHoverMarker()
  }

  const selectNodeObject = (object, point = null) => {
    clearHoveredObject()
    clearPlacementSelectionState()
    clearNavigationPointSelectionState()
    state.selectedObject = object
    state.selectedPoint = point ? point.clone() : null
    refreshSelectionHelper()
    renderInspector()
    syncNodeMappingFormDefaults()
    notifyEmbedSelectionChanged()
  }

  const selectPlacement = (placement, point = null) => {
    clearHoveredObject()
    clearNodeSelectionState()
    clearNavigationPointSelectionState()
    state.selectedPlacement = placement
    state.selectedPlacementObject = state.placementObjectsById.get(placement.id) || null
    state.selectedPlacementPoint = point ? point.clone() : null
    refreshSelectionHelper()
    renderInspector()
    syncPlacementNodeMappingFormDefaults()
    notifyEmbedSelectionChanged()
  }

  const selectPlacementPoint = (point) => {
    clearHoveredObject()
    clearNodeSelectionState()
    clearNavigationPointSelectionState()
    state.selectedPlacement = null
    state.selectedPlacementObject = null
    state.selectedPlacementPoint = point ? point.clone() : null
    refreshSelectionHelper()
    renderInspector()
  }

  const selectNavigationPoint = (navigationPoint) => {
    clearHoveredObject()
    clearNodeSelectionState()
    clearPlacementSelectionState()
    state.selectedNavigationPoint = navigationPoint
    state.selectedNavigationPointObject = state.navigationPointObjectsById.get(navigationPoint.id) || null
    refreshSelectionHelper()
    renderInspector()
    notifyEmbedSelectionChanged()
  }

  const clearSelectedObject = () => {
    clearNodeSelectionState()
    clearPlacementSelectionState()
    clearNavigationPointSelectionState()
    state.nodeMappingFormNodeKey = null
    state.placementNodeMappingFormPlacementId = null
    clearSelectionHelper()
    clearSelectionMarker()
    renderInspector()
    notifyEmbedSelectionChanged()
  }

  return {
    clearNodeSelectionState,
    clearPlacementSelectionState,
    clearNavigationPointSelectionState,
    selectNodeObject,
    selectPlacement,
    selectPlacementPoint,
    selectNavigationPoint,
    setHoveredObject,
    clearHoveredObject,
    clearSelectedObject
  }
}
